<section id="content" class="consultancy-details" *ngIf="this.lang">
  <div class="page page-profile">

    <!-- page header -->
    <div class="pageheader">
      <h2>{{lang.viewConsultancy }}</h2>
      <div class="page-bar">
        <ul class="page-breadcrumb">
          <li>
            <a [routerLink]="'/'+AppFrontRoutes.DASHBOARD"><i class="fa fa-home"></i>
              {{AppSettings.SITE_TITLE | titlecase}}</a>
          </li>
          <li>
            <a [routerLink]="'/'+AppFrontRoutes.Servicing_List">{{lang.viewConsultancy }}</a>
          </li>
          <li>
            <span *ngIf="single_data">{{ single_data.consultancy_code }}</span> / <span *ngIf="cust_data">{{
              cust_data.bussines_name }}</span>
          </li>

        </ul>

        <div style="float: right;">
          <div class="social-icons">
            <!-- <a class="plus-vdead" (click)="viewServicing()"
              [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
              <i class="fa fa-list"></i>
            </a> -->

            <a class="plus-edit" [routerLink]="['/'+AppFrontRoutes.EDIT_CONSULTANCY+'/'+this.id]"
              [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
              <i class="fa fa-edit"></i>
            </a>
          </div>
        </div>

      </div>
    </div>
    <!-- page content -->
    <div class="pagecontent">

      <!-- row -->
      <div class="row">
        <div class="col-md-12">
          <div class="tile tile-simple">

            <!-- tile body -->
            <div class="tile-body" [ngSwitch]="pageView">
              <div role="tabpanel" *ngSwitchCase="'list'">

                <!-- Nav tabs -->
                <ul class="nav nav-tabs tabs-dark" role="tablist">
                  <li role="presentation" class="active"><a href="#generalTab" aria-controls="feedTab" role="tab"
                      data-toggle="tab">{{ lang.generalData }}</a></li>

                  <li role="presentation"><a href="#planningTab" aria-controls="feedTab" role="tab" data-toggle="tab">{{
                      lang.planning }}</a></li>

                  <li role="presentation"><a href="#taskTab" aria-controls="feedTab" role="tab" data-toggle="tab">{{
                      lang.tasktobeDone }}</a></li>

                  <li role="presentation"><a href="#documentsTab" aria-controls="feedTab" role="tab"
                      data-toggle="tab">{{ lang.documents }}</a></li>

                  <li role="presentation"><a href="#protocolTab" aria-controls="feedTab" role="tab" data-toggle="tab">{{
                      lang.protocol }}</a></li>

                </ul>

                <div class="tab-content">

                  <div role="tabpanel" class="tab-pane active" id="generalTab">
                    <div class="wrap-reset">

                      <div class="row">
                        <form [formGroup]="generalsForm" class="form-validation">
                          <div class="form-group col-sm-6">
                            <div class="form-group col-sm-12">
                              <div class="col-sm-3">
                                <label for="code">{{ lang.code }}</label>
                              </div>
                              <div class="col-sm-9">
                                <input type="text" class="form-control" formControlName="code" readonly>
                              </div>
                            </div>

                            <div class="form-group col-sm-12">
                              <div class="col-sm-3">
                                <label for="customer">{{ lang.customer }}</label>
                              </div>
                              <div class="col-sm-9">
                                <input type="text" class="form-control" formControlName="customer" readonly>
                              </div>
                            </div>

                            <div class="form-group col-sm-12">
                              <div class="col-sm-2">
                                <label for="address">{{ lang.typeofContract }}</label>
                              </div>

                              <div class="col-sm-2">
                                <label for="address">{{ lang.type }}</label>

                              </div>

                              <div class="col-sm-2">
                                <label for="address">{{ lang.startingDate }}</label>
                              </div>


                              <div class="col-sm-2">
                                <label for="address">{{ lang.meetingsper }}</label>
                              </div>

                              <div class="col-sm-2">
                                <label for="address">{{ lang.contract }}</label>
                              </div>

                              <div class="col-sm-2">
                                <label for="address">{{ lang.amount }}</label>
                              </div>
                            </div>

                            <div class="form-group col-sm-12">
                              <div class="col-sm-2">
                              </div>

                              <div class="col-sm-2">
                                <div *ngFor="let ctype of contract_type let i = index">
                                  <input type="text" class="form-control" value="{{ ctype }}" disabled>
                                </div>
                              </div>

                              <div class="col-sm-2">
                                <div *ngFor="let sdate of starting_date let i = index">
                                  <input type="text" class="form-control" value="{{ sdate }}" disabled>
                                </div>
                              </div>


                              <div class="col-sm-2">
                                <div *ngFor="let myear of meeting_year let i = index">
                                  <input type="text" class="form-control" value="{{ myear }}" disabled>
                                </div>
                              </div>

                              <div class="col-sm-2">
                                <div *ngFor="let amt of amount let i = index">
                                  <input type="text" class="form-control" value="" disabled>
                                </div>
                              </div>

                              <div class="col-sm-2">
                                <div *ngFor="let amt of amount let i = index">
                                  <input type="text" class="form-control" value="{{ amt }}" disabled>
                                </div>
                              </div>
                            </div>



                          </div>
                        </form>

                        <div class="form-group col-sm-6">

                          <div role="tabpanel">

                            <!-- <div class="row p-10">

                              <div class="col-sm-9">
                              </div>

                               <div class="col-sm-3">
                                <div class="social-icons">
                                  <a class="plus-export" (click)="setPageView('list')">
                                    <span class="glyphicon glyphicon-list"></span>
                                  </a>
                                  <a class="plus-export" (click)="setPageView('calendar')">
                                    <span class="glyphicon glyphicon-calendar"></span>
                                  </a>
                                </div>
                              </div> 

                            </div> -->

                            <app-consultancy-calendar></app-consultancy-calendar>
                          </div>

                        </div>
                      </div>
                    </div>


                  </div>

                  <div role="tabpanel" class="tab-pane" id="planningTab">

                    <div class="row p-10">

                      <div class="col-sm-2">

                        <div class="social-icons">


                          <a class="plus-add" (click)="add_intervention(this.id)"
                            [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'" title="Add">
                            <i class="fa fa-plus"></i>
                          </a>


                          <a class="plus-export" data-toggle="modal" data-target="#datatableExport1"
                            data-options="splash-2 splash-ef-4">
                            <span class="glyphicon glyphicon-export"></span>
                          </a>


                          <a class="plus-copy" (click)="multiplaningDuplicate()" data-action="show" data-id=""
                            [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
                            <span class="glyphicon glyphicon-file"></span>
                          </a>

                          <a class="plus-delete" *ngIf="deleteOption" (click)="multiplaningDelete()"
                            [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
                            <span class="glyphicon glyphicon-trash"></span>
                          </a>

                        </div>
                      </div>
       
                      <div class="col-sm-2">
                        <select class="form-control" (change)="datatableFilterAction()" [(ngModel)]="filter1">
                          <option value="">{{ lang.selectYear }}</option>
                              <option *ngFor="let resp of year" [ngValue]="resp">{{resp}}</option>
                        </select>
                      </div>
                      
                      <div  class="col-sm-8">
                        <input
                        style="float: right;width: 20%;"
                        #planningSearch
                        id="planningSearch"
                        type="text"
                        class="form-control"
                        placeholder="Search"
                        aria-label="Search"
                        aria-describedby="basic-addon1"
                      />                        
                      </div>      

                    </div>

                    <div ng-app="testmyApp" class="form-group" style="overflow: auto;">
                      <table datatable [dtOptions]="datatableOptions1" class="table-striped table-sm row-border hover"
                        id="table1" *ngIf="planing_data">
                        <thead>
                          <tr>
                            <th>Hidden.No</th>
                            <th>
                              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                                <input type="checkbox"><i></i>
                              </label>
                            </th>
                            <th>No.</th>
                            <th>{{ plang?.reportNo }}</th>
                            <th>{{ plang?.date }}</th>
                            <th>{{ plang?.type }}</th>
                            <th>{{ plang?.performedBy }}</th>
                            <th>{{ plang?.totalHours }}</th>
                            <th>{{ plang?.pdfReport }}</th>
                            <th>{{ plang?.distributionStatus }}</th>
                            <th>{{ plang?.sendTo }}</th>
                            <th>{{ plang?.dateOfsend }}</th>
                            <th>{{ plang?.action }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let record of planing_data let i = index" id="{{record.planningId}}">
                            <td>{{i+1}}</td>
                            <td></td>
                            <td>{{i+1}}</td>
                            <td>{{record.report_no}}</td>
                            <td>{{record.date}}</td>
                            <td>{{record.type }}</td>
                            <td><a [routerLink]="['/'+AppFrontRoutes.CONSULTANCY_VIEW+'/'+this.id]">{{record.employee_name }}</a></td>
                            <td>{{record.thours }}</td>
                            <td><a href="http://vmi313621.contaboserver.net/Software_backend/{{record.pdfFilePath}}" target="_blank"><img src="{{ record.pdf_url }}" style="width: 45px;"></a>
                            </td>
                            <td>
                              <!-- {{record.distribution_staus }} -->
                              <div [innerHTML]="record.dist_staus"></div>
                            </td>
                            <td>{{record.sent_to }}</td>
                            <td>{{record.date_of_sent }}</td>
                            <td>
                              <div class="btn-group dropup">

                                <button type="button" class="btn btn-info dropdown-toggle circle_btn"
                                  data-toggle="dropdown" aria-expanded="false"><i class="fa fa-tasks"></i></button>

                                <ul class="dropdown-menu dropdown-menu-right action_btn" role="menu">

                                  <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a
                                      class="delete_action" (click)="delete_planing(record.planningId)"><i
                                        class="fa fa-trash"></i> {{ plang.erase }}</a></li>


                                  <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a
                                      class="edit_action" (click)="edit_intervention(record.planningId,this.id)"><i
                                        class="fa fa-pencil-square-o"></i> {{ plang.modify }}</a></li>


                                  <li><a (click)="view_intervention(record.planningId,this.id)"
                                      class="blue_action"><i class="glyphicon glyphicon-eye-open"></i>
                                      {{plang.view}}</a></li>



                                  <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a class=""
                                      (click)="edit_operating(record.planningId)"><i
                                        class="fa fa-envelope-o fa-fw text-blue mar-rt-8"></i> {{ plang.mail }}</a></li>
                                </ul>
                              </div>
                            </td>

                          </tr>
                        </tbody>

                      </table>
                    </div>

                  </div>

                  <div role="tabpanel" class="tab-pane" id="taskTab">

                    <div class="row p-10">
                      <div class="col-sm-3">

                        <div class="social-icons">


                          <a class="plus-add" (click)="add_newTask(this.id)"
                            [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'" title="Add">
                            <i class="fa fa-plus"></i>
                          </a>


                          <a class="plus-export" data-toggle="modal" data-target="#datatableExport2"
                            data-options="splash-2 splash-ef-4">
                            <span class="glyphicon glyphicon-export"></span>
                          </a>


                          <a class="plus-copy" (click)="multitaskDuplicate()" data-action="show" data-id=""
                            [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
                            <span class="glyphicon glyphicon-file"></span>
                          </a>

                          <a class="plus-delete" *ngIf="deleteOption" (click)="multitaskDelete()"
                            [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
                            <span class="glyphicon glyphicon-trash"></span>
                          </a>

                        </div>

                      </div>

                      <div  class="col-sm-9">
                        <input
                        style="float: right;width: 20%;"
                        #taskSearch
                        id="taskSearch"
                        type="text"
                        class="form-control"
                        placeholder="Search"
                        aria-label="Search"
                        aria-describedby="basic-addon1"
                      />                        
                      </div>                            

                    </div>

                    <div ng-app="testmyApp" class="form-group" style="overflow: auto;">
                      <table datatable [dtOptions]="datatableOptions2" class="table-striped table-sm row-border hover"
                        id="table2" *ngIf="get_task_data">
                        <thead>
                          <tr>
                            <th>Hidden.No</th>
                            <th>
                              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                                <input type="checkbox"><i></i>
                              </label>
                            </th>
                            <th>No</th>
                            <th>{{ tlang?.tasktobeDone }}</th>
                            <th>{{ tlang?.input }}</th>
                            <th>{{ tlang?.levelofRisk }}</th>
                            <th>{{ tlang?.dateofCreation }}</th>
                            <th>{{ tlang?.expectedClosing }}</th>
                            <th>{{ tlang?.daysLeft }}</th>
                            <th>{{ tlang?.closingDate }}</th>
                            <th>{{ tlang?.status }}</th>
                            <th>{{ tlang?.responsible }}</th>
                            <th>{{ tlang?.action }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let trecord of get_task_data let j = index" id="{{trecord.taskId}}">
                            <td>{{j+1}}</td>
                            <td></td>
                            <td>{{j+1}}</td>
                            <td><a href="javascript:void(0);" (click)="view_newTask(trecord.taskId,this.id)" >{{trecord.task_done }}</a></td>
                            <td>{{trecord.task_input}}</td>
                            <td>{{trecord.risk }}</td>
                            <td>{{trecord.creation_date }}</td>
                            <td>{{trecord.closing_date }}</td>
                            <td>{{ trecord.days_left }}</td>
                            <td>{{trecord.close_date }}</td>
                            <td>
                              <!-- <div [innerHTML]="trecord.status"></div> -->
                              <div *ngIf="trecord.status == '1'; else elsepart; ">
                                <button class="status_danger">Open</button>
                              </div>
                              <ng-template #elsepart>
                                <button class="status_success">Closed</button>
                              </ng-template>
                              
                            </td>
                            <td>{{trecord.responsible }}</td>
                            <td>
                              <div class="btn-group dropup">

                                <button type="button" class="btn btn-info dropdown-toggle circle_btn"
                                  data-toggle="dropdown" aria-expanded="false"><i class="fa fa-tasks"></i></button>

                                <ul class="dropdown-menu dropdown-menu-right action_btn" role="menu">
                                  <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a
                                      class="delete_action" (click)="delete_newTask(trecord.taskId,this.id)"><i
                                        class="fa fa-trash"></i> {{ tlang.erase }}</a></li>

                                  <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a
                                      class="edit_action" (click)="edit_newTask(trecord.taskId,this.id)"><i
                                        class="fa fa-pencil-square-o"></i> {{ tlang.modify }}</a></li>

                                  <li><a (click)="view_newTask(trecord.taskId,this.id)" 
                                      class="blue_action"><i class="glyphicon glyphicon-eye-open"></i>
                                      {{tlang.view}}</a></li>
                                </ul>
                              </div>
                            </td>

                          </tr>
                        </tbody>

                      </table>
                    </div>

                  </div>

                  <div role="tabpanel" class="tab-pane" id="documentsTab">

                    <div class="row p-10">

                      <div class="col-sm-3">

                        <div class="social-icons">

                          <a class="plus-add" (click)="add_newDocument(this.id)"
                            [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'" title="Add">
                            <i class="fa fa-plus"></i>
                          </a>

                          <a class="plus-export" data-toggle="modal" data-target="#datatableExport3"
                            data-options="splash-2 splash-ef-4">
                            <span class="glyphicon glyphicon-export"></span>
                          </a>

 
                          <a class="plus-copy" (click)="multidocDuplicate()" data-action="show" data-id=""
                            [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
                            <span class="glyphicon glyphicon-file"></span>
                          </a>

                          <a class="plus-delete" *ngIf="deleteOption" (click)="multidocDelete()"
                            [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
                            <span class="glyphicon glyphicon-trash"></span>
                          </a>

                        </div>

                      </div>

                      <div  class="col-sm-9">
                        <input
                        style="float: right;width: 20%;"
                        #docsSearch
                        id="docsSearch"
                        type="text"
                        class="form-control"
                        placeholder="Search"
                        aria-label="Search"
                        aria-describedby="basic-addon1"
                      />                        
                      </div>                           

                    </div>

                    <div ng-app="testmyApp" class="form-group" style="overflow: auto;">
                      <table datatable [dtOptions]="datatableOptions3" class="table-striped table-sm row-border hover"
                        id="table3" *ngIf="document_data">
                        <thead>
                          <tr>
                            <th>Hidden.No</th>
                            <th>
                              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                                <input type="checkbox"><i></i>
                              </label>
                            </th>
                            <th>S/N</th>
                            <th>{{ dlang?.code }}</th>
                            <th>{{ dlang?.title }}</th>
                            <th>{{ dlang?.revision }}</th>
                            <th>{{ dlang?.date }}</th>
                            <th>{{ dlang?.writtenBy }}</th>
                            <th>{{ dlang?.documentStatus }}</th>
                            <th>{{ dlang?.attachments }}</th>
                            <th>{{ dlang?.action }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let drecord of document_data let k = index" id="{{drecord.documentId}}">
                            <td>{{k+1}}</td>
                            <td></td>
                            <td>{{k+1}}</td>
                            <td>{{drecord.code }}</td>
                            <td>{{drecord.title}}</td>
                            <td>{{drecord.revision }}</td>
                            <td>{{drecord.date }}</td>
                            <td>{{drecord.written_name }}</td>
                            <td>{{drecord.doc_status }}</td>
                            <td>
                              <div *ngFor='let attach of drecord.attachments.split(",")'>
                                <a href="http://vmi313621.contaboserver.net/Software_backend/uploads/consultancy/{{attach}}"
                                  target="_blank">{{attach}}</a>
                              </div>
                            <td>
                              <div class="btn-group dropup">

                                <button type="button" class="btn btn-info dropdown-toggle circle_btn"
                                  data-toggle="dropdown" aria-expanded="false"><i class="fa fa-tasks"></i></button>

                                <ul class="dropdown-menu dropdown-menu-right action_btn" role="menu">
                                  <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a
                                      class="delete_action" (click)="delete_newDoc(drecord.documentId,this.id)"><i
                                        class="fa fa-trash"></i> {{ dlang.erase }}</a></li>

                                  <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a
                                      class="edit_action" (click)="edit_newDocument(drecord.documentId,this.id)"><i
                                        class="fa fa-pencil-square-o"></i> {{ dlang.modify }}</a></li>

                                  <li><a (click)="view_newDocument(drecord.documentId,this.id)" class="blue_action"><i
                                        class="glyphicon glyphicon-eye-open"></i>
                                      {{dlang.view}}</a></li>
                                </ul>
                              </div>
                            </td>

                          </tr>
                        </tbody>

                      </table>
                    </div>

                  </div>

                  <div role="tabpanel" class="tab-pane" id="protocolTab">

                    <div class="row p-10">
                      <div class="col-sm-3">

            
                        <div class="social-icons">

                          <a class="plus-add" (click)="add_newProtocol(this.id)"
                          [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'" title="Add">
                          <i class="fa fa-plus"></i>
                        </a>

                        
                          <a class="plus-export" data-toggle="modal" data-target="#datatableExport4"
                            data-options="splash-2 splash-ef-4" title="Export">
                            <span class="glyphicon glyphicon-export"></span>
                          </a>


                          <a class="plus-copy" (click)="multiprotDuplicate()" data-action="show" data-id=""
                            [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'" title="Duplicate">
                            <span class="glyphicon glyphicon-file"></span>
                          </a>

                          <a class="plus-delete" *ngIf="deleteOption" (click)="multiprotDelete()"
                            [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'" title="Erase">
                            <span class="glyphicon glyphicon-trash"></span>
                          </a>

                        </div>

                      </div>

                      <div  class="col-sm-9">
                        <input
                        style="float: right;width: 20%;"
                        #protocolSearch
                        id="protocolSearch"
                        type="text"
                        class="form-control"
                        placeholder="Search"
                        aria-label="Search"
                        aria-describedby="basic-addon1"
                      />                        
                      </div>  

                    </div>

                    <div ng-app="testmyApp" class="form-group" style="overflow: auto;">
                      <table datatable [dtOptions]="datatableOptions4" class="table-striped table-sm row-border hover"
                        id="table4" *ngIf="protocol_data">
                        <thead>
                          <tr>
                            <th>Hidden.No</th>
                            <th>
                              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                                <input type="checkbox"><i></i>
                              </label>
                            </th>
                            <th>S/N</th>
                            <th>{{ prlang?.code }}</th>
                            <th>{{ prlang?.type }}</th>
                            <th>{{ prlang?.topics }}</th>
                            <th>{{ prlang?.description }}</th>
                            <th>{{ prlang?.date }}</th>
                            <th>{{ prlang?.addresser }}</th>
                            <th>{{ prlang?.addressee }}</th>
                            <th>{{ prlang?.attachments }}</th>
                            <th>{{ prlang?.action }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let precord of protocol_data let k = index" id="{{precord.protocolId}}">
                            <td>{{k+1}}</td>
                            <td></td>
                            <td>{{k+1}}</td>
                            <td>{{ precord.const_code }}</td>
                            <td>{{precord.type}}</td>
                            <td>{{precord.topic }}</td>
                            <td>{{precord.discription }}</td>
                            <td>{{precord.pro_date }}</td>
                            <td>{{precord.addresser }}</td>
                            <td>{{precord.addressee }}</td>
                            <td>

                              <div *ngFor='let attach of precord.attachments.split(",")'>
                                <a href="http://vmi313621.contaboserver.net/Software_backend/uploads/consultancy/{{attach}}"
                                  target="_blank">{{attach}}</a>
                              </div>


                            </td>
                            <td>
                              <div class="btn-group dropup">

                                <button type="button" class="btn btn-info dropdown-toggle circle_btn"
                                  data-toggle="dropdown" aria-expanded="false"><i class="fa fa-tasks"></i></button>

                                <ul class="dropdown-menu dropdown-menu-right action_btn" role="menu">
                                  <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a
                                      class="delete_action" (click)="delete_protocols(precord.protocolId)"><i
                                        class="fa fa-trash"></i> {{ prlang.erase }}</a></li>

                                  <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a
                                      class="edit_action" (click)="edit_newProtocol(precord.protocolId,this.id)"><i
                                        class="fa fa-pencil-square-o"></i> {{ prlang.modify }}</a></li>

                                  <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a
                                      class="blue_action" (click)="view_newProtocol(precord.protocolId,this.id)"><i
                                        class="glyphicon glyphicon-eye-open"></i>
                                      {{prlang.view}}</a></li>
                                </ul>
                              </div>
                            </td>

                          </tr>
                        </tbody>

                      </table>
                    </div>

                  </div>






                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

    </div>
  </div>
</section>

<div class="modal splash fade" id="datatableExport1" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">{{ plang?.selectColumns }}</h3>
      </div>

      <div class="modal-body column_export">
        <div class="row select-alls">
          <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
              (change)="export1_select_deselect_all($event)"><i></i> {{ plang?.selectAll }} </label>
        </div>
        <div class="row flexs">

          <div class="active-left">
            <h2>{{ plang?.activeColumns }}</h2>

            <div class="row" *ngFor="let option of datatableCols1">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export1_select_deselect($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div>

        </div>

      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn1" class="export_dynamic_btn">
        </div>
        <button class="btn btn-warning" data-dismiss="modal">{{ plang?.close }}</button>
      </div>

    </div>
  </div>
</div>

<div class="modal splash fade" id="datatableExport2" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">{{ tlang?.selectColumns }}</h3>
      </div>

      <div class="modal-body column_export">
        <div class="row select-alls">
          <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
              (change)="export2_select_deselect_all($event)"><i></i> {{ tlang?.selectAll }} </label>
        </div>
        <div class="row flexs">

          <div class="active-left">
            <h2>{{ tlang?.activeColumns }}</h2>

            <div class="row" *ngFor="let option of datatableCols2">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export2_select_deselect($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div>

        </div>

      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn2" class="export_dynamic_btn">
        </div>
        <button class="btn btn-warning" data-dismiss="modal">{{ tlang?.close }}</button>
      </div>

    </div>
  </div>
</div>


<div class="modal splash fade" id="datatableImport2" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <!-- <div class="modal-header">
          <h3 class="modal-title custom-font">IMPORT HOURLY DATA</h3>
          <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
            <span aria-hidden="true">&times;</span>
          </button>
      
        </div>
         -->
      <div class="modal-header">
        <h4 class="modal-title pull-left">Import Employee Data</h4>
        <button type="button" class="close pull-right" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>


      <div class="modal-body column_export">
        <div class="row">
          <form>
            <input type="file" class="filestyle" id="file" name='file' data-buttonText="Choose file"
              (change)="onPhotoPickerChange($event)">

            <font style="vertical-align: inherit;">
              <font style="vertical-align: inherit;"><a href="">Click Here</a> {{ emplang?.todownloadtocsv}}</font>
            </font>
          </form>
        </div>
      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn2" class="export_dynamic_btn">
        </div>
        <button type="button" class="btn btn-primary" (click)="onclick(this.id)">{{ emplang?.submit }}</button>
        <!-- <button class="btn btn-warning" data-dismiss="modal">Close</button>-->
        <button type="button" class="btn btn-warning" data-dismiss="modal">{{ emplang?.close }}</button>

      </div>
    </div>
  </div>
</div>

<div class="modal splash fade" id="datatableExport3" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">{{ dlang?.selectColumns }}</h3>
      </div>

      <div class="modal-body column_export">
        <div class="row select-alls">
          <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
              (change)="export3_select_deselect_all($event)"><i></i> {{ dlang?.selectAll }} </label>
        </div>
        <div class="row flexs">

          <div class="active-left">
            <h2>{{ dlang?.activeColumns }}</h2>

            <div class="row" *ngFor="let option of datatableCols3">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export3_select_deselect($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div>

        </div>

      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn3" class="export_dynamic_btn">
        </div>
        <button class="btn btn-warning" data-dismiss="modal">{{ dlang?.close }}</button>
      </div>

    </div>
  </div>
</div>

<div class="modal splash fade" id="datatableExport4" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">{{ prlang?.selectColumns }}</h3>
      </div>

      <div class="modal-body column_export">
        <div class="row select-alls">
          <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
              (change)="export4_select_deselect_all($event)"><i></i> {{ prlang?.selectAll }} </label>
        </div>
        <div class="row flexs">

          <div class="active-left">
            <h2>{{ plang?.activeColumns }}</h2>

            <div class="row" *ngFor="let option of datatableCols4">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export4_select_deselect($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div>

        </div>

      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn4" class="export_dynamic_btn">
        </div>
        <button class="btn btn-warning" data-dismiss="modal">{{ prlang?.close }}</button>
      </div>

    </div>
  </div>
</div>



<div class="modal splash fade" id="datatableExport5" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">{{ plang?.selectColumns }}</h3>
      </div>

      <div class="modal-body column_export">
        <div class="row select-alls">
          <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
              (change)="export5_select_deselect_all($event)"><i></i> {{ plang?.selectAll }} </label>
        </div>
        <div class="row flexs">

          <div class="active-left">
            <h2>{{ plang?.activeColumns }}</h2>

            <div class="row" *ngFor="let option of datatableCols5">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export5_select_deselect($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div>

        </div>

      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn5" class="export_dynamic_btn">
        </div>
        <button class="btn btn-warning" data-dismiss="modal">{{ plang?.close }}</button>
      </div>

    </div>
  </div>
</div>